import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SuccessIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M9.995 19.99c5.468 0 9.995-4.537 9.995-9.995C19.99 4.527 15.453 0 9.985 0 4.527 0 0 4.527 0 9.995c0 5.458 4.537 9.995 9.995 9.995Zm0-1.666a8.29 8.29 0 0 1-8.32-8.329c0-4.625 3.685-8.33 8.31-8.33a8.306 8.306 0 0 1 8.34 8.33 8.297 8.297 0 0 1-8.33 8.33ZM8.917 14.65c.324 0 .598-.157.794-.46l4.478-7.046c.108-.196.235-.412.235-.628 0-.44-.392-.725-.803-.725-.245 0-.49.157-.676.441l-4.067 6.526-1.93-2.498c-.236-.314-.451-.392-.726-.392a.76.76 0 0 0-.754.774c0 .215.088.421.225.607l2.391 2.94c.245.323.51.46.833.46Z"
  })
});
export default SuccessIcon;